/**
 * The query parameters used by UNO Web
 */ export var WebQueryParams;
(function(WebQueryParams) {
    /** Called after logout */ WebQueryParams["Logout"] = "logout";
    /** AAD User ID */ WebQueryParams["UserId"] = "userObjectId";
    /** AAD UPN (UserPrincipalName) */ WebQueryParams["Upn"] = "auth_upn";
    /** Tenant ID */ WebQueryParams["TenantId"] = "tid";
    /** Locale Override */ WebQueryParams["Mkt"] = "mkt";
    /** Query param from a ocdi redirect */ WebQueryParams["OcdiRedirect"] = "ocdiRedir";
    /** Query param from a ocdi timestamp as unix time in seconds */ WebQueryParams["OcdiTimestamp"] = "ocdiTs";
    /** Query param from a ocdi guid */ WebQueryParams["OcdiGuid"] = "ocdiId";
    /** Web redirect indication parameter */ WebQueryParams["UnowebRedirect"] = "unowebRedir";
    /** Query param to indicate no prompt should be shown */ WebQueryParams["NoPrompt"] = "noPrompt";
    /** Query param to route request to correct planner service region */ WebQueryParams["PlannerRouteHint"] = "PlannerRouteHint";
})(WebQueryParams || (WebQueryParams = {}));
export var WebUrlSegments;
(function(WebUrlSegments) {
    /** Web UI prefix */ WebUrlSegments["WebUI"] = "webui";
    /** Gcc specific sub route path */ WebUrlSegments["GccPath"] = "gcc";
    /** Blank msal redirect path */ WebUrlSegments["BlankMsalRedirect"] = "blankmsalredirect";
    /** Redirect bridge path for MSAL */ WebUrlSegments["RedirectBridge"] = "redirectbridge";
    /** Redirect bridge2 path for MSAL */ WebUrlSegments["RedirectBridge2"] = "redirectbridge2";
})(WebUrlSegments || (WebUrlSegments = {}));
export var WebAuthEventNames;
(function(WebAuthEventNames) {
    WebAuthEventNames["SuiteNavLogoutEventName"] = "suiteNavLogout";
})(WebAuthEventNames || (WebAuthEventNames = {}));
/** The value of query parameter logout on success */ export const LogoutSuccessfulQueryParamValue = "1";
